import React, { useState } from 'react';
import EngineIcon from '../../../../assets/svg/engine.svg';
import styles from './DeviceEngineHistory.module.scss';
import LocalPersonTile from '../../PersonTabPage/LocalPeopleTile';

const DeviceEngineHistory = ({ body, alwaysOpen, title, cssOrder, isPinned, showPin, property }) => {
  const [collapsed, setCollapsed] = useState<boolean>(true);

  if (alwaysOpen) {
    setCollapsed(false);
  }

  return (
    <LocalPersonTile
      collapsible
      initialCollapsed={collapsed}
      title={title}
      action={null}
      order={cssOrder}
      leftIcon={null}
      property={property}
      withPin={showPin}
      isPinned={isPinned}
    >
      <div className={styles.DeviceEngineBody}>{body}</div>
    </LocalPersonTile>
  )
}

export default DeviceEngineHistory;
